
import Vue from 'b2b-common/vue-config'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'b2b-common/vue-config/axios'
import router from 'b2b-common/vue-config/router'
import 'b2b-common/vue-config/bootstrap.scss'
import '@/assets/scss/bootstrap-custom.scss'
import 'flag-icon-css/css/flag-icon.min.css'
import './config/vee-validate'
import './config/gettext'
import routes from './routes'
import App from './app.vue'

// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/server/' : 'https://b2bstaging.aquatour.bg/server/'
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/server/' : 'https://b2bstaging.helloholidays.ro/server/'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB9SeBY-QoV8yQKLZmPtegnMoKIghWN0fU'
  }
})

router.addRoutes(routes)

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
